import { DialogTitle } from "@headlessui/react";
import type { EventFragment } from "~/__generated__/graphql/graphql";
import { StepIndicator } from "~/components/plans/components/StepIndicator";
import { CheckoutFooter } from "./CheckoutFooter";
import { getVisibleTicketVariations } from "./ticketVariations";

export function CheckoutTicketsSkeleton({ plan, label }: { plan: EventFragment; label: string }) {
  const variations = getVisibleTicketVariations(plan);
  const rows = variations.length ? variations : [null];
  const group = plan.allowGroupRSVPs && plan.maxTicketsPerPurchase > 1 && plan.myRequest?.state !== "IN_ACCEPTED_WAITLIST";

  return (
    <div className="flex min-h-0 flex-1 flex-col sm:block" aria-busy="true">
      <DialogTitle className="sr-only">{label}</DialogTitle>
      <p role="status" className="sr-only">{label}</p>
      <div aria-hidden="true" className="flex min-h-0 flex-1 flex-col motion-safe:animate-pulse sm:block">
        <div className="shrink-0">
          <StepIndicator currentStep={1} showTicketStep />
        </div>
        <div className="-mx-6 mt-[10px] min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 pt-[30px] pb-2 sm:mx-0 sm:overflow-visible sm:px-0 sm:pb-6">
          <div className="h-8 w-56 max-w-full rounded bg-butter-cream/70" />
          <div className="mt-2.5 flex flex-col gap-3">
            {rows.map((variation, index) => (
              <div key={variation?.id ?? index} className="overflow-hidden rounded-xl bg-white">
                <div className="flex items-center gap-3 p-[0.6rem] sm:p-[0.8rem]">
                  <span className="size-11 shrink-0 rounded-lg bg-butter-cream/70" />
                  <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                    <span className="h-5 w-28 max-w-full rounded bg-butter-cream/70" />
                    {variation?.description && <span className="h-4 w-40 max-w-full rounded bg-butter-cream/70" />}
                  </div>
                  <span className="h-5 w-14 shrink-0 rounded bg-butter-cream/70" />
                </div>
                {group && variation?.available && (
                  <div className="flex items-center justify-between gap-3 border-t border-butter-cream-light px-[0.6rem] py-[0.4rem] sm:px-[0.8rem]">
                    <span className="h-4 w-20 rounded bg-butter-cream/70" />
                    <span className="h-11 w-28 rounded bg-butter-cream/70" />
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="mt-5">
            <div className="mb-3 flex items-center justify-between gap-3">
              <span className="h-6 w-20 rounded bg-butter-cream/70" />
              <span className="h-6 w-24 rounded bg-butter-cream/70" />
            </div>
            <div className="mb-1.5 h-5 w-28 rounded bg-butter-cream/70" />
            <div className="h-12 rounded-lg bg-white/70" />
          </div>
        </div>
        <CheckoutFooter showTerms={false}>
          <div className="h-12 rounded-lg bg-butter-cream/70" />
        </CheckoutFooter>
      </div>
    </div>
  );
}
